// extracted by mini-css-extract-plugin
module.exports = {"container":"AverageScore_container__33JC9","insideBox":"AverageScore_insideBox__1vnMw","scores":"AverageScore_scores__2Jy9X"};